import request from '@/api/request'

export function reset (id) {
  return request({
    url: '/user/admin/' + id + '/mfa',
    method: 'put'
  })
}
